import { mapValues } from "lodash"
import type {
  BasketParamListItem,
  BasketParamResponseItem,
  BasketParamsResponse,
} from "../../lib/api/basket"

function ItemParamsCreate({
  item_id,
  plan_id,
  type,
  resolver,
  params = {},
}: BasketParamListItem) {
  return {
    item_id,
    plan_id,
    resolver,
    type,
    params: mapValues(params, (param: BasketParamResponseItem) => ({
      ...param,
      id: param.paramId,
      name: param.paramName,
    })),
  }
}

export const BasketParamsCollection = (paramsList: BasketParamsResponse) =>
  mapValues(paramsList, ItemParamsCreate)
